import { create, node } from '@dojo/framework/core/vdom';

const factory = create({ node });

/**
 * scroll middleware
 *
 * `scrollIntoView` moves a node into the viewport
 * `scrollTo` moves a node to a given position based on `ScrollToOptions`
 */
export const scroll = factory(({ middleware: { node } }) => {
	return {
		scrollIntoView(key: string | number, focusKey?: string | number): boolean {
			const domNode = node.get(key);
			if (!domNode) {
				return false;
			}
			domNode.scrollIntoView(true);
			if (focusKey) {
				const focusNode = node.get(focusKey);
				if (focusNode) {
					focusNode.focus();
				}
			}
			return true;
		},
		scrollTo(key: string | number, options?: ScrollToOptions): boolean {
			const domNode = node.get(key);
			if (!domNode) {
				return false;
			}
			domNode.scrollTo(options);
			return true;
		}
	};
});
